import DynamicPageWrapperV2 from 'pages/DynamicPageV2/DynamicPageWrapper';

export const DynamicPageWrapper = () => <DynamicPageWrapperV2 />;
